import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const SEARCH_CLASS_NAME = tv({
  base: "flex gap-2 rounded py-[8px] px-[16px]",
  variants: {
    transparent: {
      true: clsx(
        "ring-1 ring-grayScale-200 [&_svg]:fill-grayScale-200 text-base-0",
        // hover
        "hover:ring-grayScale-0 [&_svg]:hover:fill-grayScale-0",
      ),
      // FIXME: focus状態でhoverしたときはring-2にしたい
      false: clsx(
        "bg-ui-white [&_svg]:fill-grayScale-400",
        // hover
        "hover:ring-1 hover:ring-grayScale-400",
        // focus
        "focus-within:ring-grayScale-400 focus-within:ring-2",
      ),
    },
  },
});
